import type { ButtonHTMLAttributes } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  fullWidth?: boolean;
}

const VARIANTS = {
  primary:
    'bg-terracotta text-cream-light hover:bg-terracotta-dark disabled:opacity-50',
  secondary: 'bg-paper text-brown border border-cream-dark hover:bg-cream-dark',
  ghost: 'bg-transparent text-brown hover:bg-cream-dark',
} as const;

export function Button({
  variant = 'primary',
  fullWidth,
  className = '',
  ...rest
}: ButtonProps): JSX.Element {
  return (
    <button
      className={`rounded-full px-5 py-3 text-sm font-semibold transition-colors disabled:cursor-not-allowed ${VARIANTS[variant]} ${
        fullWidth ? 'w-full' : ''
      } ${className}`}
      {...rest}
    />
  );
}
